var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.699 31.991",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.063012 0 0 .063012 -3.5148 -17.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m362.47 399.37c-80.452 0.30312-160.77 30.425-222.31 90.281l55.906 55.281c92.256-89.611 240.75-90.142 333.66-1.1562l55.781-55.813c-62.01-59.39-142.58-88.897-223.03-88.594zm-166.41 145.56-0.125 0.0937z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.37 281.37c-110.95 0.41801-221.72 41.957-306.59 124.5l55.469 54.844c138.94-134.56 362.26-135.24 502.03-1.375l56.656-55.781c-85.514-81.901-196.62-122.61-307.56-122.19zm-251.12 179.34-0.5625 0.53125z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.34 516.87c-50.088 0.18872-100.12 18.953-138.44 56.219l53.438 52.812c47.181-45.821 123.11-46.068 170.62-0.5625l53.219-53.312c-38.607-36.975-88.756-55.345-138.84-55.156zm-85 109.03-0.063 0.0625z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-473.55 131.71)",
    d: "m780.99 634.37a78.5 78.5 0 0 1-0.0574-110.96 78.5 78.5 0 0 1 110.96-0.17211 78.5 78.5 0 0 1 0.28684 110.96 78.5 78.5 0 0 1-110.96 0.40159l55.278-55.737z",
    color: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi_icon.86eee34f596bbb107a31bb28f27eab53.svg";
export { ForwardRef as ReactComponent };